import React from "react"
import { connect } from "react-redux"

import { InventoryProductList as ProductList } from "./product-list"
import ButtonsBar from "../../components/buttons-bar"
import track from '../../utils/mixpanel-event'

class Inventory extends React.Component {
  constructor(props) {
    super(props);
    this.state = {currentShopIndex: 0}

    this.onChangeShop = index => {
      this.setState({currentShopIndex: index});
      this.props.changeShop(this.props.shopItems[index].id)
    }
    track('Page View', {page: 'Inventory'})
  }

  render() {
    const currentShop = this.props.shopItems[this.state.currentShopIndex]

    return (
      <div>
        <ButtonsBar items={this.props.shopItems} selected={this.state.currentShopIndex}
            onClick={this.onChangeShop} className="shop-inventory__buttons" />
        <ProductList currency={currentShop.currency} />
      </div>
    )
  }
}

const mapStateToProps = state => ({
  shopItems: state.shopList.items,
})

const mapDispatchToProps = dispatch => ({
  changeShop: (id) => dispatch({type: "SHOP_CHANGE", id})
})

export default connect(mapStateToProps, mapDispatchToProps)(Inventory)
